<template>
    <v-col style="display: flex;">
        <AppLogo
            class="mt-2"
            :app="appStoreDialogState.appData"
            :is-app-dialog="true"
            :region-code="selectedAccount.region_code"
            :company="selectedAccount"
        />
        <div class="pl-9 pt-2" style="max-width: 80%">
            <div class="d-flex align-center">
                <div class="font-weight-medium title">
                    {{ getRegionAppTitle(appStoreDialogState.appData.name, selectedAccount.region_code, selectedAccount) }}
                </div>
                <EliteChipMenu
                    v-if="getManifestData(appStoreDialogState.appData.name, 'isElite')"
                    :company-id="selectedAccount.id"
                    :is-waiting-list="appStoreDialogFlags.isWaitingList()"
                    @upgrade-bundle="close_dialog"
                />
            </div>

            <div class="body-2 g4--text">
                {{ getManifestData(appStoreDialogState.appData.name, "description", selectedAccount) }}
            </div>
        </div>
        <v-spacer/>
        <icon-button @click="close_dialog">close</icon-button>
    </v-col>
</template>


<script>
import {getManifestData} from "@/views/AppStore/app-store-manifest";
import {actions} from "@/store/modules/dialog";
import AppLogo from "@/views/AppStore/AppLogo";
import RightsModule from "@/composables/use-rights";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import {$t} from "@/i18n";
import {computed} from "@vue/composition-api";
import {getRegionAppTitle} from "../../../helpers/helpers";
import EliteChip from "../../../components/Elite/EliteChip.vue";
import AccountModule from '@/store/modules/account'
import EliteChipMenu from "../../../components/Elite/EliteChipMenu.vue";

export default {
    name: "AppStoreDialogHeader",
    components: {
        EliteChipMenu,
        EliteChip,
        AppLogo
    },
    props: {
        showSubscriptionInfo: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const {
            appStoreDialogFlags,
            appStoreDialogActions,
            appStoreDialogGetters,
            appStoreDialogState
        } = appStoreDialog()
        const { isAccountElite } = AccountModule()
        const {can_edit_account} = RightsModule();
        const close_dialog = function () {
            ctx.emit("close");
        };

        const selectedAccount = computed(() => {
            return appStoreDialogGetters.getSelectedCompany()
        })

        return {
            ...actions,
            close_dialog,
            getManifestData,
            can_edit_account,
            appStoreDialogGetters,
            appStoreDialogFlags,
            appStoreDialogActions,
            appStoreDialogState,
            selectedAccount,
            getRegionAppTitle,
            isAccountElite
        };
    }
};
</script>